export default {
      id: "icon-coeur-pride-usage",
      viewBox: "0 0 108.3 95.7",
      url: __webpack_public_path__ + "icons.svg#icon-coeur-pride",
      toString: function () {
        return this.url;
      }
    }